// Third party
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const americanFormatWithGMT = (dateString: string | null) => {
  if (!dateString) return 'N/A';

  const date = dayjs(dateString).tz();
  const offset = date.format('Z');
  const showOffset = offset.length <= 6 ? ` GMT${offset}` : '';

  return `${date.format('MMMM D, YYYY | hh:mm A')}${showOffset}`;
};

const formatDateLabel = (timestamp?: string) => {
  if (!timestamp) return { date: '', time: '' };

  const date = dayjs(timestamp).format('MMMM D, YYYY');
  const time = `${dayjs(timestamp).format('h:mm A')} (GMT${dayjs().format('Z')})`;

  return { date, time };
};

export { americanFormatWithGMT, formatDateLabel };